import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "@/i18n";
import Logo from "@/components/Logo";

export default function Footer() {
  const { t } = useTranslation();
  const { lang: langParam } = useParams();
  const lang = SUPPORTED_LANGS.includes(langParam) ? langParam : "ar";

  return (
    <footer className="ag-footer" id="footer">
      <div className="ag-container ag-footer__grid">
        <div className="ag-footer__brand">
          <Logo />
          <p className="ag-footer__tagline">{t("footer.tagline")}</p>
          <a className="ag-footer__email" href={`mailto:${t("footer.contactEmail")}`}>
            {t("footer.contactEmail")}
          </a>
        </div>

        <div>
          <h4 className="ag-footer__title">{t("footer.navTitle")}</h4>
          <ul className="ag-footer__list">
            <li>
              <NavLink to={`/${lang}`} end>
                {t("nav.home")}
              </NavLink>
            </li>
            <li>
              <a href={`/${lang}#sectors`}>{t("nav.sectors")}</a>
            </li>
            <li>
              <a href={`/${lang}#analysis`}>{t("nav.analysis")}</a>
            </li>
            <li>
              <a href={`/${lang}#contact`}>{t("nav.contact")}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="ag-footer__title">{t("footer.legalTitle")}</h4>
          <ul className="ag-footer__list">
            <li>
              <NavLink to={`/${lang}/privacy-policy`}>{t("nav.privacy")}</NavLink>
            </li>
            <li>
              <NavLink to={`/${lang}/cookie-policy`}>{t("nav.cookies")}</NavLink>
            </li>
            <li>
              <NavLink to={`/${lang}/terms`}>{t("nav.terms")}</NavLink>
            </li>
          </ul>
        </div>

        <div className="ag-footer__company">
          <h4 className="ag-footer__title">{t("footer.companyTitle")}</h4>
          <p className="ag-footer__companyName">{t("footer.companyName")}</p>
          <p>{t("footer.address")}</p>
          <ul className="ag-footer__meta">
            <li>
              <span>{t("footer.taxIdLabel")}</span> {t("footer.taxIdValue")}
            </li>
            <li>
              <span>{t("footer.registrationLabel")}</span> {t("footer.registrationValue")}
            </li>
            <li>
              <span>{t("footer.licenseLabel")}</span> {t("footer.licenseValue")}
            </li>
            <li>
              <span>{t("footer.jurisdictionLabel")}</span> {t("footer.jurisdictionValue")}
            </li>
            <li>
              <span>{t("footer.incorporatedLabel")}</span> {t("footer.incorporatedValue")}
            </li>
          </ul>
        </div>
      </div>

      <div className="ag-footer__bottom">
        <div className="ag-container ag-footer__bottomInner">
          <p className="ag-footer__disclaimer">{t("footer.disclaimer")}</p>
          <p className="ag-footer__copy">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}
